// SPDX-License-Identifier: AGPL-3.0-or-later

import {createElementHost} from '@app/features/holiday/utils/createElementHost';

export const HOLIDAY_FLYBY_HOST_SELECTOR = '[data-flx="holiday.holiday-layer.flybys-host"]';

const flybyHost = createElementHost();

export const setHolidayFlybyHost = flybyHost.set;
export const getHolidayFlybyHost = flybyHost.get;
export const subscribeHolidayFlybyHost = flybyHost.subscribe;

const FALLBACK_CROSS_WIDTH_PX = 1280;

export function getHolidayFlybyCrossWidthPx(): number {
	const hostWidth = flybyHost.get()?.clientWidth ?? 0;
	if (hostWidth > 0) return hostWidth;
	if (typeof window !== 'undefined' && window.innerWidth > 0) return window.innerWidth;
	return FALLBACK_CROSS_WIDTH_PX;
}
